export default __webpack_public_path__ + "static/media/section0-bg2.efb786bd.png";